import React from 'react';

import { Grid, Group, Stack, Text, Title } from '@mantine/core';
import { IconRotateClockwise2 } from '@tabler/icons-react';
import CreditsProgressBar from 'components/CreditsProgressBar';
import { useLocalization } from 'context/localization-context';
import dayjs from 'dayjs';
import { CreditDispensation } from 'types';

const CreditDispensationRow = ({
  creditDispensation,
}: {
  creditDispensation: CreditDispensation;
}): JSX.Element => {
  const { dateFormat } = useLocalization();

  let expirationDate = creditDispensation.expirationDate;
  let earlyCancel = false;
  if (creditDispensation.isRollover === false && creditDispensation.athletePackageCancellationDate) {
    if (
      !creditDispensation.expirationDate ||
      dayjs(creditDispensation.athletePackageCancellationDate) < dayjs(creditDispensation.expirationDate)
    ) {
      expirationDate = creditDispensation.athletePackageCancellationDate;
      earlyCancel = true;
    }
  }

  return (
    <Grid columns={5}>
      <Grid.Col span={3}>
        <Stack spacing={0}>
          <Title order={6} color='dimmed'>
            {creditDispensation.name}
          </Title>
          <Group>
            <Text size='sm' color='dimmed' fs='italic'>
              {!creditDispensation.credits && '-'}

              {creditDispensation.credits && (
                <>
                  {dayjs(creditDispensation.dispenseDate).format(dateFormat)} -{' '}
                  {expirationDate && (
                    <>
                      <>{dayjs(expirationDate).format(dateFormat)}</>
                      {earlyCancel && <Text>Early Cancellation </Text>}
                    </>
                  )}
                  {!expirationDate && creditDispensation.credits && `${creditDispensation.credits} Credits`}
                  {!expirationDate && !creditDispensation.credits && 'None'}
                </>
              )}
            </Text>
            {creditDispensation.isRollover && (
              <Group>
                <IconRotateClockwise2 size={16} color='green' />
                <Text color='green' size='xs'>
                  Rollover Credits
                </Text>
              </Group>
            )}
          </Group>
        </Stack>
      </Grid.Col>
      <Grid.Col span={2}>
        <CreditsProgressBar
          totalCredits={creditDispensation.credits}
          creditsUsed={creditDispensation.creditsUsed}
        />
      </Grid.Col>
    </Grid>
  );
};

export default CreditDispensationRow;
